import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Campanii',
  filters: {
    search: 'Căutați campanii...',
  },
  columns: {
    title: 'Titlu',
    created_by: 'Creat de',
    schedule_mode: 'Mod programare',
    scheduled_at: 'Programat la',
    sent_at: 'Trimis la',
    status: 'Stare',
    sent: 'Trimis',
    delivered: 'Livrat',
    delivered_rate: 'Rată de livrare',
    clicks: 'Clicuri',
    click_rate: 'Rată de accesare',
    live: 'Live',
    actions: 'Acțiuni',
  },
  active_status: {
    draft: 'Ciornă',
    active: 'Activ',
  },
  delivery: {
    in_progress: 'În așteptarea confirmării',
    awaiting: 'În așteptarea confirmării',
    verified: 'Verificat {{relative}}',
    next_check_around: 'Următoarea verificare în jurul orei {{time}}',
  },
  breakdown: {
    delivered: '{{count}} livrate',
    pending: '{{count}} în așteptarea confirmării',
    failed_title: 'Nelivrat',
    all_delivered: 'Livrat tuturor destinatarilor.',
    load_error: 'Nu s-a putut încărca rezumatul livrării.',
    reasons: {
      DeviceNotRegistered: 'Aplicație eliminată sau notificări dezactivate (token expirat)',
      MessageRateExceeded: 'Limitat temporar de Expo',
      MessageTooBig: 'Payload notificare prea mare',
      MismatchSenderId: 'Neconcordanță credențiale push',
      InvalidCredentials: 'Credențiale push invalide',
      batch_failed: 'Trimiterea lotului a eșuat',
      missing_ticket: 'Nicio confirmare returnată de Expo',
      unknown: 'Eroare necunoscută de livrare',
    },
  },
  created_by: {
    [CreatedBy.System]: 'Sistem',
    [CreatedBy.User]: 'Utilizator',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Instant',
    [ScheduleMode.Scheduled]: 'Programat',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'Se trimite',
    [DeliveryStatus.Sent]: 'Trimis',
    [DeliveryStatus.Queued]: 'În coadă',
    [DeliveryStatus.Failed]: 'Eșuat',
  },
  actions: {
    details: 'Detalii',
    view_details: 'Vezi detalii',
    resend: 'Retrimite',
    duplicate_edit: 'Duplică și editează',
    delete: 'Șterge',
    edit: 'Editează',
    activate: 'Activează',
    deactivate: 'Dezactivează',
  },
  success_messages: {
    campaign_updated: 'Campania a fost actualizată cu succes',
    campaign_deleted: 'Campania a fost ștearsă cu succes',
  },
  error_messages: {
    failed_to_update_campaign: 'Actualizarea campaniei a eșuat',
    failed_to_load_data: 'Eroare la încărcarea datelor',
    failed_to_delete_campaign: 'Ștergerea campaniei a eșuat',
  },
};
